export interface SessionPreviewDto {
  symbol: string
  mondayTrade: string
  mondayQuote: string
  tuesdayTrade: string
  tuesdayQuote: string
  wednesdayTrade: string
  wednesdayQuote: string
  thursdayTrade: string
  thursdayQuote: string
  fridayTrade: string
  fridayQuote: string
  saturdayTrade: string
  saturdayQuote: string
  sundayTrade: string
  sundayQuote: string
}

export interface UploadSessionsPreviewRequest {
  servers: string[]
  file: File
}
export enum SessionPreviewUploadKey {
  symbol = 'symbol',
  mondayTrade = 'mondayTrade',
  mondayQuote = 'mondayQuote',
  tuesdayTrade = 'tuesdayTrade',
  tuesdayQuote = 'tuesdayQuote',
  wednesdayTrade = 'wednesdayTrade',
  wednesdayQuote = 'wednesdayQuote',
  thursdayTrade = 'thursdayTrade',
  thursdayQuote = 'thursdayQuote',
  fridayTrade = 'fridayTrade',
  fridayQuote = 'fridayQuote',
  saturdayTrade = 'saturdayTrade',
  saturdayQuote = 'saturdayQuote',
  sundayTrade = 'sundayTrade',
  sundayQuote = 'sundayQuote',
}
